import {RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {Game, GameInventorySetting, UpdateGameInventorySettingItem} from "../../models/games";
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function gamesListApi(): Promise<RequestResultValue<Game[]>> {
    let url = `admin/games`;
    const response = await HttpService.getInstance().requestGetAsync(url);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<Game[]>(true, body as Game[]);
    }
    return new RequestResultValue<Game[]>(false);
}

export async function upsertGameApi({game, file}: { game:Game, file?: File}): Promise<RequestResultValue<Game>> {
    const data = new Map<string, any>();
    data.set('id', game.id);
    data.set('name', game.name);
    data.set('alias', game.alias);
    data.set('contextId', game.contextId);
    data.set('isActive', game.isActive);
    data.set('sortOrder', game.sortOrder);
    data.set('inventoryLimit', game.inventoryLimit);
    if (game.orderItemsLimit) {
        data.set('orderItemsLimit', game.orderItemsLimit);
    }
    if (game.offlineBidsActivatePercent != null) {
        data.set('offlineBidsActivatePercent', game.offlineBidsActivatePercent);
    }
    if (game.offlineBidsDeactivatePercent != null) {
        data.set('offlineBidsDeactivatePercent', game.offlineBidsDeactivatePercent);
    }
    data.set('isNew', game.isNew??false);
    const response = await HttpService.getInstance().multipartRequestAsync(
        'admin/games/upsert',
        data,
        "POST",
        file ? [{name: 'file', file: file}] : []
    );
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<Game>(true, body as Game);
    }
    return new RequestResultValue<Game>(false);
}

/** Настройки способов загрузки инвентаря игры (GamesController.GetInventorySettings) */
export async function inventorySettingsList(gameId: number): Promise<RequestResultValue<GameInventorySetting[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/games/${gameId}/inventory-settings`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<GameInventorySetting[]>(true, body as GameInventorySetting[]);
    }
    return new RequestResultValue<GameInventorySetting[]>(false);
}

/**
 * Обновление настроек способов загрузки инвентаря игры (GamesController.UpdateInventorySettings).
 * Не переданные способы не изменяются. Возвращает актуальный список настроек.
 */
export async function inventorySettingsUpdate(gameId: number, settings: UpdateGameInventorySettingItem[])
    : Promise<RequestResultValue<GameInventorySetting[]>> {
    const response = await HttpService.getInstance().requestPostAsync(
        `admin/games/${gameId}/inventory-settings`,
        JSONbig.stringify({settings: settings})
    );
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<GameInventorySetting[]>(true, body as GameInventorySetting[]);
    }
    return new RequestResultValue<GameInventorySetting[]>(false);
}
